import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class CatalogueUpdatesService implements OnDestroy {

    public catalogueUpdated = new Subject();
    public refreshRequired: boolean = false;

    constructor() { }

    catalogueUpdateComplete() {
        this.catalogueUpdated.next();
    }

    ngOnDestroy() {
        this.catalogueUpdated.next();
    }
}